export default "__VITE_ASSET__f3f9a03d__"